import type { AccountExecutive } from '../types/accountExecutiveMaintenance';

export const mockAccountExecutives: AccountExecutive[] = [
  {
    id: '1',
    aeCode: 'H018197',
    firstName: 'GA - IN Z-A MARKETING',
    middleName: 'INSURANCE AGENCY',
    lastName: '-',
    isActive: true,
    createdAt: new Date('2024-01-15'),
    lastModified: new Date('2025-01-16')
  },
  {
    id: '2',
    aeCode: 'D0100985',
    firstName: 'Information Technology',
    middleName: '-',
    lastName: '-',
    isActive: true,
    createdAt: new Date('2024-02-10'),
    lastModified: new Date('2025-01-15')
  },
  {
    id: '3',
    aeCode: 'H018859',
    firstName: 'WEST',
    middleName: '-',
    lastName: '-',
    isActive: true,
    createdAt: new Date('2024-03-05'),
    lastModified: new Date('2025-01-14')
  },
  {
    id: '4',
    aeCode: 'H018752',
    firstName: 'DIRECT - TRAVEL SALES',
    middleName: '-',
    lastName: '-',
    isActive: true,
    createdAt: new Date('2024-04-20'),
    lastModified: new Date('2025-01-16')
  },
  {
    id: '5',
    aeCode: 'D0204770',
    firstName: 'TRAVEL TSM DAVAO',
    middleName: '-',
    lastName: '-',
    isActive: false,
    createdAt: new Date('2024-05-12'),
    lastModified: new Date('2024-12-20')
  },
  {
    id: '6',
    aeCode: 'H018771',
    firstName: 'GRACE ALEXIS',
    middleName: 'B',
    lastName: 'ACIERTO',
    isActive: true,
    createdAt: new Date('2024-06-01'),
    lastModified: new Date('2025-01-13')
  },
  {
    id: '7',
    aeCode: 'H016441',
    firstName: 'Merjoyce',
    middleName: 'Flores',
    lastName: 'Adaban',
    isActive: true,
    createdAt: new Date('2024-07-08'),
    lastModified: new Date('2025-01-12')
  },
  {
    id: '8',
    aeCode: 'H031919',
    firstName: 'CARMEL ANN',
    middleName: 'E',
    lastName: 'ALCIBAR',
    isActive: true,
    createdAt: new Date('2024-08-15'),
    lastModified: new Date('2025-01-11')
  },
  {
    id: '9',
    aeCode: 'H999999',
    firstName: 'BC Test',
    middleName: 'AE',
    lastName: 'Account Executive',
    isActive: true,
    createdAt: new Date('2024-09-22'),
    lastModified: new Date('2025-01-10')
  }
];